module.exports = __webpack_public_path__ + "static/media/screen2.26fc8aa1.png";